export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VuesticMultiSelect.vue?vue&type=template&id=078e9dd0"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-multi-select/VuesticMultiSelect.vue?vue&type=template&id=078e9dd0
// module id = 18iG
// module chunks = 41